class AudioTrack {
  constructor (enabled = true, id = null, kind = null, label = null, language = null) {
    this._list = null
    this._enabled = enabled
    this.id = id
    this.kind = kind
    this.label = label
    this.language = language
  }

  get enabled () {
    return this._enabled
  }

  set enabled (value) {
    if (this._enabled === value) {
      return
    }
    this._enabled = value
    if (value) {
      this._list.setActiveTrack(this)
    }
    return true
  }

  set list (value) {
    this._list = value
  }
}

export default AudioTrack
